export default {"src":"/_next/static/media/search-main.f482e745.svg","height":18,"width":18,"blurWidth":0,"blurHeight":0};